export const UPDATE_STATEMENT_TEMPLATE_REQUEST = 'UPDATE_STATEMENT_TEMPLATE_REQUEST';

export const updateStatementTemplateRequest = ( id, updateData ) => ({
    type: UPDATE_STATEMENT_TEMPLATE_REQUEST,
    payload: {
        id,
        updateData
    }
});
